export class InventarioTaller {
    idModuloInventario: number;
    cantidad: number;
    concepto: string;
    folioFiscal: string;
    fechaCompra: Date;
    comentario: string;
    idFacturaCompra: number;
    idProveedor: number;
    proveedor: string;
    status: string;
    idSucursal: number;
    sucursal: string;
    idModuloTipoInventario: number;
    idEmpleado: number;
    modulo: string;
}

export class StatusInventario {
    idStatusInventario: number;
    clave: string;
    descripcion: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/inventarioTaller.ts